var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.company)?_c('router-link',{attrs:{"to":{ name: 'CompanyShow', params: {id: _vm.data.company['@id']} }}},[_vm._v("\n  "+_vm._s(_vm.data.company.code)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }